







































import Vue from 'vue';
import { Message } from 'mycorems-app-shared';
import { CampaignRecipient } from '@/types';
import extract, { getCustomFieldValue } from './customField';

export default Vue.extend({
  props: {
    recipients: {
      type: Array as () => CampaignRecipient[],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      headings: ['Email', 'Name'],
    };
  },
  computed: {
    customFields(): string[] {
      return extract(this.recipients);
    },
  },
  methods: {
    getCustomFieldValue,
  },
  components: {
    message: Message,
  },
});
